import React, { useState, useEffect } from 'react';
import { Box, IconButton, Popover, Tooltip } from '@mui/material';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { DateRangePicker } from 'react-date-range';
// import { Calendar as DateRangePicker} from "react-date-range";

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import locale from 'date-fns/locale/en-GB';
import dayjs from 'dayjs';

const CustomDateRangePicker = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [range, setRange] = useState([
    {
      startDate: props.value[0].toDate(),
      endDate: props.value[1].toDate(),
      key: 'selection',
    },
  ]);
  const [focusDateRange, setFocusDateRange] = React.useState([0, 0]);

  useEffect(() => {
    if (!calendarOpen) {
      const startChanged =
        props.value[0].toDate().getTime() !== range[0].startDate.getTime();
      const endChanged =
        props.value[1].toDate().getTime() !== range[0].endDate.getTime();

      if (startChanged || endChanged) {
        props.setDateRangeValue([
          dayjs(range[0].startDate),
          dayjs(range[0].endDate),
        ]);
      }
    }
  }, [calendarOpen]);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setCalendarOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setCalendarOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'date-range-popover' : undefined;

  const today = new Date();
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const startOfLastMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  );
  const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
  const startOfYear = new Date(today.getFullYear(), 0, 1);
  const oneYearAgo = new Date(
    today.getFullYear() - 1,
    today.getMonth(),
    today.getDate()
  );

  const predefinedRanges = [
    {
      label: 'Last 7 Days',
      range: () => ({
        startDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 7
        ),
        endDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 1
        ),
      }),
      isSelected: () => false,
    },
    {
      label: 'Month to Date',
      range: () => ({
        startDate: startOfMonth,
        endDate: today,
      }),
      isSelected: () => false,
    },
    {
      label: 'The Previous Month',
      range: () => ({
        startDate: startOfLastMonth,
        endDate: endOfLastMonth,
      }),
      isSelected: () => false,
    },
    {
      label: 'Year To Date',
      range: () => ({
        startDate: startOfYear,
        endDate: today,
      }),
      isSelected: () => false,
    },
    {
      label: 'Last One Year',
      range: () => ({
        startDate: oneYearAgo,
        endDate: today,
      }),
      isSelected: () => false,
    },
    {
      label: 'Financial Year',
      range: () => ({
        startDate: new Date(today.getFullYear() - 1, 3, 1),
        endDate: new Date(today.getFullYear(), 3, 0),
      }),
      isSelected: () => false,
    },
    {
      label: 'Reset',
      range: () => ({
        startDate: oneYearAgo,
        endDate: today,
      }),
      isSelected: () => false,
    },
  ];

  const handleRangeChange = item => {
    var date = [dayjs(item.selection.startDate), dayjs(item.selection.endDate)];
    var close = focusDateRange[1] === 1 ? true : false;
    setRange([item.selection]);
    if (close) {
      handleClose();
    }
  };

  return (
    <div>
      <Tooltip title="Date Filter" arrow>
        <IconButton onClick={handleClick} size="small">
          <CalendarMonthOutlinedIcon />
        </IconButton>
      </Tooltip>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ zIndex: '15' }}
      >
        <Box>
          <DateRangePicker
            onChange={handleRangeChange}
            // onChange={(item) => setRange([item.selection])}
            showSelectionPreview={false}
            // moveRangeOnFirstSelection={false}
            direction="horizontal"
            months={1}
            // months={2}
            ranges={range}
            editableDateInputs={true}
            locale={locale}
            staticRanges={predefinedRanges}
            inputRanges={[]}
            focusedRange={focusDateRange}
            onRangeFocusChange={DateRange => {
              setFocusDateRange(DateRange);
            }}
          />
        </Box>
      </Popover>
    </div>
  );
};

export default CustomDateRangePicker;
